import { useMemo } from "react";

export function useTablePageItemsOptions(totalItems: number): number[] {
  return useMemo(() => {
    if (totalItems < 10) {
      return [totalItems]; 
    }

    if (totalItems <= 30) {
      const options = [5, 10, totalItems];
      return Array.from(new Set(options)).filter(v => v <= totalItems);
    }

    if (totalItems <= 300) {
      const options = [10, 20, 50, 100];
      if (totalItems > 100) options.push(200);
      if (!options.includes(totalItems)) options.push(totalItems);
      return options.filter(v => v <= totalItems);
    }

    if (totalItems <= 1000) {
      return [20, 50, 100, 200, 500, totalItems].filter(v => v <= totalItems);
    }

    return [50, 100, 200, 500];
  }, [totalItems]);
}
